import { buildQueryHelpers, OperationIds } from '../../util'
import { CollectionQueryKey } from '../../util/types'

export type WorkflowsKey = CollectionQueryKey<OperationIds.ReadWorkflowsV2>

export const readWorkflows = buildQueryHelpers<
  OperationIds.ReadWorkflowsV2,
  WorkflowsKey
>('workflow', OperationIds.ReadWorkflowsV2)
